import React from 'react';
import { theme } from '../../theme';
import type { Achievement } from '../../types/achievement';

interface Props {
  achievement: Achievement;
  onContinue: () => void;
}

export const AchievementRevealPopup: React.FC<Props> = ({ achievement, onContinue }) => {
  return (
    <div
      data-testid="achievement-reveal-popup"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1003,
      }}
    >
      <div
        style={{
          width: '90%',
          maxWidth: '380px',
          backgroundColor: theme.colors.surface,
          borderRadius: theme.borderRadius.card,
          border: `2px solid ${achievement.color}`,
          padding: theme.spacing.lg,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          boxShadow: theme.colors.shadow,
        }}
      >
        <span style={{ fontSize: '80px', marginBottom: theme.spacing.sm }} aria-hidden>
          {achievement.icon}
        </span>
        <h3
          style={{
            margin: `0 0 ${theme.spacing.xs} 0`,
            color: achievement.color,
            fontFamily: theme.fonts.heading,
            fontSize: theme.fonts.sizeTitle,
            fontWeight: theme.fonts.weightBold,
            letterSpacing: theme.fonts.letterSpacingWide,
          }}
        >
          {achievement.name}
        </h3>
        <p
          style={{
            margin: `0 0 ${theme.spacing.md} 0`,
            color: theme.colors.text,
            fontFamily: theme.fonts.body,
            fontSize: theme.fonts.sizeBody,
          }}
        >
          {achievement.description}
        </p>
        <button
          type="button"
          data-testid="achievement-reveal-continue"
          onClick={onContinue}
          style={{
            padding: `${theme.spacing.sm} ${theme.spacing.lg}`,
            backgroundColor: theme.colors.primary,
            color: theme.colors.background,
            border: 'none',
            borderRadius: theme.borderRadius.button,
            fontSize: theme.fonts.sizeBody,
            fontFamily: theme.fonts.body,
            fontWeight: theme.fonts.weightBold,
            cursor: 'pointer',
          }}
        >
          Continuar
        </button>
      </div>
    </div>
  );
};
